/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Badge from 'shared/ui/components/Badge.vue';
import PendingRegistrations from 'shared/ui/components/analytics/PendingRegistrations.vue';
import QuickLinks from 'ui/components/analytics/QuickLinks.vue';
import ReportsList from 'ui/components/analytics/ReportsList.vue';
import TabbedCharts from 'shared/ui/components/charts/TabbedCharts.vue';

/**
 * This page shows a Workspace's main dashboard.
 *
 * @category ui.pages
 * @exports EventDashboard
 * @component
 */
const __vue_script__ = {
    name: 'EventDashboard',

    components: { Badge, PendingRegistrations, QuickLinks, ReportsList, TabbedCharts },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        // Temporary solution (read HACK) as discussed in SS-29811, to be removed and repalced by
        // a proper solution when it has been put in place. This overload the use of the analytics_v2_enabled flag
        // so that all the 'solution' is done in a single place.
        // To disable the analytics report, edit the intra ds DB for the eid and change the value of the flag to 'no-reports'
        const showReports = this.params.event.analytics_v2_enabled !== 'no-reports';
        return {
            archivalCountdownMessage: null,
            charts: ['activations'],
            eventName: '',
            isLive: false,
            mainCountdownDate: '',
            mainCountdownMessage: '',
            ready: false,
            showReports,
            showRegistrations: false
        };
    },


    computed: {
        showQuickLinks() {
            return this.$services.user.hasPermission('app_bstg.dashboard.section_links', {
                event_id: this.params.event._id, org_id: this.params.event.ownerId
            });
        }
    },

    async created() {
        try {
            if (this.$services.blueprint.isModuleInstalled('registration')) {
                const { settings } = await this.$services.pax.getRegistrationConfig(this.params.event._id);
                this.showRegistrations = settings.enabled;
            }
        } catch (error) {
            console.error('[EventDashboard] Could not load registration settings', error.message || error);
        } finally {
            this.loadHeader();
            this.ready = true;
        }
    },

    methods: {

        /**
         * Loads the header
         */
        loadHeader() {
            const event = this.params.event;
            this.eventName = this.$services.event.getName(event);

            const startDate = event.startdate;
            const endDate = event.enddate;
            const archivalDate = this.$services.event.getArchivalDate(event);
            const now = this.$utils.time.now();

            // Pre-event
            if (this.$utils.workspaces.notStarted(event)) {
                this.mainCountdownMessage = 'dashboard.countdowns.starts_in';
                this.mainCountdownDate = this.$utils.time.humanizeDateDiff(now, startDate);
                if (this.showRegistrations) {
                    this.charts.unshift('registrations');
                }
                this.charts.push('active_users');

            // Live event
            } else if (this.$utils.workspaces.isLive(event)) {
                this.isLive = true;
                this.mainCountdownMessage = 'dashboard.countdowns.ends_in';
                this.mainCountdownDate = this.$utils.time.humanizeDateDiff(now, endDate);
                this.charts.unshift('active_users');
                this.charts.push('turnouts');

                if (this.showRegistrations) {
                    this.charts.push('registrations');
                }

            // Post-event
            } else {
                this.mainCountdownMessage = 'dashboard.countdowns.finished_on';
                this.mainCountdownDate = this.$utils.time.fomatTimeWithTimezone(endDate, event.timezone, 'LL');
                if (this.$utils.time.dateIsBefore(now, archivalDate)) {
                    const archivalCountdownDays = Math.abs(this.$utils.time.timeDiff(now, archivalDate, 'days'));
                    this.archivalCountdownMessage = this.$i18n.t('dashboard.countdowns.archived_in', [archivalCountdownDays]);
                } else {
                    this.archivalCountdownMessage = this.$i18n.t('dashboard.countdowns.will_soon_be_archived');
                }
                this.charts.unshift('turnouts');
            }

            // filter out charts that user has no permission to see.
            this.charts = this.charts.filter(chartName =>
                this.$services.user.hasPermission(`app_bstg.charts.${chartName}`, { event_id: event._id, org_id: event.ownerId })
            );
        }
    }

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{staticClass:"event-dashboard"},[_c('header',[_c('h1',[_vm._v(_vm._s(_vm.eventName)),(_vm.isLive && !_vm.params.event.is_template)?_c('badge',{staticClass:"danger"},[_vm._v(_vm._s(_vm.$t('event_badges.current_stage.live')))]):_vm._e()],1),(!_vm.params.event.is_template)?_c('div',{staticClass:"countdowns"},[_c('p',[_c('i18n',{attrs:{"path":_vm.mainCountdownMessage,"tag":"span"}},[_c('strong',[_vm._v(_vm._s(_vm.mainCountdownDate))])]),(_vm.archivalCountdownMessage)?_c('span',{staticClass:"archival-countdown"},[_vm._v("("+_vm._s(_vm.archivalCountdownMessage)+")")]):_vm._e()],1)]):_vm._e()]),(_vm.showQuickLinks)?_c('section',{staticClass:"links"},[_c('quick-links',{attrs:{"event":_vm.params.event}}),_c('pending-registrations',{attrs:{"event":_vm.params.event}})],1):_vm._e(),(_vm.charts.length > 0)?_c('section',{staticClass:"charts"},[_c('tabbed-charts',{attrs:{"event":_vm.params.event,"charts":_vm.charts}})],1):_vm._e(),(_vm.showReports)?_c('section',{staticClass:"reports"},[_c('reports-list',{attrs:{"event":_vm.params.event}})],1):_vm._e()]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "EventDashboard.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__